import React from 'react';
import ErrorMessage from '../ErrorMessage';

const EmptyResult = props => (<ErrorMessage title="No results were found" description="No results were found. You may have no data to show. If applicable you could try removing some of your search criteria." {...props} />);
export default EmptyResult;
